import React from 'react'

import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

import { ViewStep } from '../../types/enums/viewStep'

interface ViewStepButtonsProps {
  steps: Array<ViewStep>
  currentStep: ViewStep
  children?: JSX.Element | Array<JSX.Element>
  setCurrentStep: (newStep: ViewStep) => void
}

const ViewStepButtons = (props: ViewStepButtonsProps): JSX.Element => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <IconButton
        disabled={props.currentStep === props.steps[0]}
        onClick={() => props.setCurrentStep(props.currentStep - 1)}
      >
        <NavigateBeforeIcon />
      </IconButton>
      {props.children}
      <IconButton
        disabled={props.currentStep === props.steps[props.steps.length - 1]}
        onClick={() => props.setCurrentStep(props.currentStep + 1)}
      >
        <NavigateNextIcon />
      </IconButton>
    </Stack>
  )
}

export default ViewStepButtons
